export default "__VITE_ASSET__CMyY5rH5__"